import type {
  ISmartFilterColumn,
  ISmartFilterColumnDataCheckbox,
  ISmartFilterColumnDataCompare,
  ISmartFilterColumnDataDatePayload,
} from '@modules/smart-filters/types';
import { ESmartFilterColumnType } from '@modules/smart-filters/enums';

export function isSmartFilterCheckboxColumnId(column?: ISmartFilterColumn): boolean {
  return column?.type === ESmartFilterColumnType.CHECKBOX;
}

export function isSmartFilterCheckboxColumnIdData<T = ISmartFilterColumnDataCheckbox>(column?: ISmartFilterColumn, data?: unknown): data is T {
  return isSmartFilterCheckboxColumnId(column);
}

export function isSmartFilterCompareColumnId(column?: ISmartFilterColumn): boolean {
  return column?.type === ESmartFilterColumnType.COMPARE;
}

export function isSmartFilterCompareColumnIdData<T = ISmartFilterColumnDataCompare>(column?: ISmartFilterColumn, data?: unknown): data is T {
  return isSmartFilterCompareColumnId(column);
}

export function isSmartFilterDateColumnId(column?: ISmartFilterColumn): boolean {
  return column?.type === ESmartFilterColumnType.DATE;
}

export function isSmartFilterDateColumnIdData<T = ISmartFilterColumnDataDatePayload>(column?: ISmartFilterColumn, data?: unknown): data is T {
  return isSmartFilterDateColumnId(column);
}
